import React, { useEffect, useState } from 'react';
import { Clock, Hourglass } from '@phosphor-icons/react';
import { useApp } from '@/context/AppContext';
import { useTime } from '@/context/TimeContext';

const fmtElapsed = (since) => {
  if (!since) return '00:00:00';
  const diff = Math.max(0, Math.floor((Date.now() - new Date(since).getTime()) / 1000));
  const h = String(Math.floor(diff / 3600)).padStart(2, '0');
  const m = String(Math.floor((diff % 3600) / 60)).padStart(2, '0');
  const s = String(diff % 60).padStart(2, '0');
  return `${h}:${m}:${s}`;
};

/**
 * Top-bar clock-in/out widget. Driven entirely by TimeContext —
 * stays in sync with TimesheetPage and any other consumer.
 */
export const ClockWidget = () => {
  const { currentOutlet } = useApp();
  const { current, busy, clockIn, clockOut } = useTime();
  const [, setTick] = useState(0);

  // Tick every second for the live timer when clocked in
  useEffect(() => {
    if (!current?.clocked_in) return;
    const t = setInterval(() => setTick((n) => n + 1), 1000);
    return () => clearInterval(t);
  }, [current?.clocked_in]);

  if (!current) return null;
  const isIn = current.clocked_in;

  return (
    <button
      onClick={() => (isIn ? clockOut() : clockIn(currentOutlet?.id))}
      disabled={busy}
      className="flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium border transition-all hover:scale-105"
      style={{
        backgroundColor: isIn ? 'rgba(34, 197, 94, 0.12)' : 'rgba(148, 163, 184, 0.12)',
        borderColor: isIn ? 'rgba(34, 197, 94, 0.4)' : 'rgba(148, 163, 184, 0.3)',
        color: isIn ? '#16a34a' : 'var(--theme-text-muted)',
      }}
      data-testid="clock-widget-btn"
      title={isIn ? 'Click to clock out' : 'Click to clock in'}
    >
      {isIn ? <Hourglass size={14} weight="fill" /> : <Clock size={14} />}
      {isIn ? (
        <span className="font-mono tabular-nums">{fmtElapsed(current.entry?.clock_in)}</span>
      ) : (
        'Clock In'
      )}
    </button>
  );
};

export default ClockWidget;
